<template>
  <v-card
    :class="['creative-container', 'justify-center', { 'selected-card': isTemplateSelected, 'creative-container-clickable': isTemplateClickable, 'creative-container-clickable-hover': (isTemplateClickable && !isImageApiCallInProgress) ,'remove-all-styles': !isElevationAndBorderVisible }]"
    @click="()=>{ goToPreview() }"
  >
    <v-card-title
      :class="['mb-0', 'renderer-card', {'pa-2': isTemplateClickable, 'pa-0': !isTemplateClickable}]"
    >
      <v-layout
        style="position: relative;"
        row
        wrap
        fill-height
        :class="{'grey lighten-3' : !isTemplateSelected, 'primary-variation-1-base' : isTemplateSelected }"
        justify-center
      >
        <v-flex xs12 grow :id="`creative-image-${template.id}`">
          <span
            v-if="!isTemplateSelected && (isLoading || !template.leadImage || !template.leadImage.url || isImageApiCallInProgress)"
            class="shimmer-loader"
          />
          <img
            :id="index"
            v-if="isTemplateSelected || (!isLoading && template.leadImage && template.leadImage.url)"
            width="100%"
            crossorigin="anonymous"
            :data-src="creativeUrl"
            :src="imageToBeDisplayed"
            @load="imageFetched"
          >
        </v-flex>
        <v-flex xs12 grow>
          <v-progress-linear
            v-if="isTemplateSelected"
            indeterminate
            class="linear-progress"
          />
        </v-flex>
      </v-layout>
    </v-card-title>
  </v-card>
</template>
<script>
import { VCard, VCardTitle, VLayout, VFlex, VProgressLinear } from 'vuetify/lib';
import { mapGetters, mapActions } from 'vuex';;
import Vue from 'vue';
import { launchState, bizgainOnboardingRoutes, cbApiUrlForTemplates, getImageSourceForCreative } from 'Features/bizgainOnboarding/constants';
import { extractCreativeDetails, getCreativeTemplate } from '../../../helpers/templateHelper';
import onboardingRedirect from 'Mixins/onboardingRedirect';
import debounce from 'lodash/debounce';
export default {
  mixins: [onboardingRedirect],
  props: {
    index: {
      type: Number,
      default: -1
    },
    template: {
      type: Object,
      default: null
    },
    passedExtractedCreativeDetails: {
      type: Object,
      default: null
    },
    isTemplateClickable: {
      type: Boolean,
      default: false
    },
    isElevationAndBorderVisible: {
      type: Boolean,
      default: true
    },
    enableOnUpdateLoader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      bizgainOnboardingRoutes,
      renderCount: 0,
      creativeUrl: '',
      extractedCreativeDetails: null,
      getCreativeDataDebounced: null,
      imageToBeDisplayed: null,
      isLoading: false,
      isTemplateSelected: false,
      isImageApiCallInProgress: true
    };
  },
  computed: {
    ...mapGetters(['isInAppCampaign', 'creativeImages', 'businessDetails', 'objective', 'selectedTemplateId', 'businessProfileId', 'roimaticCampaignId', 'roimaticConfiguration'])
  },
  mounted(){
    this.computeDefaultDimension();
  },
  async created(){
    await this.updateCreativeData(this.passedExtractedCreativeDetails);
  },
  watch: {
    passedExtractedCreativeDetails: {
      handler(value) {
        if(value && (this.enableOnUpdateLoader || this.renderCount == 0)){
          this.renderCount++
          this.$emit('on-image-load-started')
          if(this.renderCount > 1){
            this.setIsCreativeEdited(true);
          }
          this.isLoading = true;
          this.isImageApiCallInProgress = this.enableOnUpdateLoader;
          this.getCreativeData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['setIsCreativeEdited', 'patchBusinessDetails', 'setCreativeImages', 'updateCreativeLoader', 'clearMessages']),

    async updateCreativeData(newExtractedCreativeDetails = null){
      if(this.template.leadImage && this.template.leadImage.url){
        this.computeDefaultDimension();
        this.extractedCreativeDetails = newExtractedCreativeDetails ? newExtractedCreativeDetails : extractCreativeDetails(this.businessDetails);
        this.creativeUrl = `${cbApiUrlForTemplates(this.template.publishedRoimaticCreativeSetId, 0.5)}&${getCreativeTemplate(this.objective, this.template.type, this.template.logo, this.template.leadImage, this.extractedCreativeDetails)}`;
        this.updateCreativeImage({ templateId: this.template.id,  canvasImage: this.creativeUrl });
        this.imageToBeDisplayed = this.isTemplateClickable ? '' : await getImageSourceForCreative(this.creativeUrl);
      }
    },
    updateCreativeImage(e){
      this.setCreativeImages(e);
      this.updateCreativeLoader(null);
    },
    async goToPreview() {
      if(this.creativeUrl && this.isTemplateClickable && !this.isLoading && !this.isImageApiCallInProgress){
        if((this.businessDetails && this.businessDetails.shortenFlow) || (this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
          this.$emit('setTemplateId', this.template.id);
        }else{
          this.isLoading = true;
          this.isTemplateSelected = true;
          await this.updateSelectedTemplateId(this.template.id);
        }
      }
    },
    async updateSelectedTemplateId(templateId){
      let businessDetailsToUpdate = JSON.parse(JSON.stringify(this.businessDetails));
      if (businessDetailsToUpdate) {
        let selectedTemplateId = templateId;
        Vue.set(businessDetailsToUpdate.creativeDetail, 'selectedTemplateId', parseInt(selectedTemplateId));
      }
      await this.redirect({ id: this.template.id, isAppFlow: true }, { ...this.$route.params, id: this.template.id, isAppFlow: true }, false, launchState.CREATIVESPREVIEW, businessDetailsToUpdate);
    },
    async getCreativeData(){
      if(!this.template.hasOwnProperty('leadImage') || !this.template.hasOwnProperty('logo'))
      {
        return;
      }
      if(this.getCreativeDataDebounced){
        this.getCreativeDataDebounced.cancel();
      }
      this.getCreativeDataDebounced = debounce(async function(){
        this.clearMessages();
        await this.updateCreativeData(this.passedExtractedCreativeDetails)
        this.isLoading = false;
      }, 50);
      this.getCreativeDataDebounced();
    },
    computeDefaultDimension(){
      let creativeImage = document.getElementById(`creative-image-${this.template.id}`);
      if(creativeImage){
        if(creativeImage.clientWidth){
          creativeImage.style.height = `${creativeImage.clientWidth}px`;
        }
        else{
          creativeImage.style.minWidth = '100px';
          creativeImage.style.minHeight = '100px';
          creativeImage.style.width = '100%';
          creativeImage.style.height = '100%';
        }
      }
    },
    imageFetched(){
      this.isImageApiCallInProgress = false;
      this.updateCreativeLoader(null);
      this.$emit('on-image-load-finished', this.index);
    }
  },
  destroyed () {
    if(process.env.VUE_APP_CAPACITOR_ENVIRONMENT === 'true')
    {
      URL.revokeObjectURL(this.imageToBeDisplayed);
    }
  },
  components: {
    VCard,
    VCardTitle,
    VLayout,
    VFlex,
    VProgressLinear
  }
};
</script>
<style lang="scss" scoped>

.renderer-card{
  height: 100%;
  overflow: hidden !important;
}

.remove-all-styles {
  all: unset !important;
}
.creative-image{
  border: 1px solid var(--v-black-base);
}

.selected-card {
  border: solid 1px var(--v-primary-base);
  background-color: var(--v-primary-variation-1-base);
}

.creative-container {
  max-width: 500px;
  max-height: 500px;
  border: solid 1px transparent;
}

.creative-container-clickable {
  max-width: 250px !important;
  max-height: 250px !important;
  cursor: pointer;
}

.creative-container-clickable-hover:hover{
  border: solid 1px var(--v-primary-base);
  background-color: var(--v-primary-variation-1-base);
  transition: none;
}

.shimmer-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 80%
    ),
    lightgray;
  background-repeat: repeat-y;
  background-size: 400% 100%;
  background-position: 0 0;
  animation: shine 1.2s infinite;
}

@keyframes shine {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.linear-progress {
  position: absolute;
  height: 4px !important;
  bottom: 0;
  margin: 0 0 -4px 0;
  padding: 0;
}

@media screen and (max-width: 600px) {
  .creative-container {
    max-width: 400px;
    max-height: 400px;
  }
  .creative-container-clickable {
    max-width: 150px !important;
    max-height: 150px !important;
  }
}
</style>